import React from 'react';
import { connect } from 'react-redux';
import { getCompleted } from './../../../../store/reducers/orders';

const OrdersCompleted = props => {
  const { elems, keys } = props;
  return (
    <div className='completedContainer' style={{padding: '10px'}}>
      <div className='completedList' style={{display: 'flex', flexDirection: 'column'}}>
        {
          keys.map(key => {
            return (
              <div>
                {elems[key].id}
              </div>
            )
          })
        }
      </div>
    </div>
  );
}

export default connect(
  state => {
    const elems = getCompleted(state.orders);
    return ({ elems, keys: Object.keys(elems) })
  }
)(OrdersCompleted);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/completed.js